<template>
	<el-dialog
		v-bind="$attrs"
		:modal="false"
		class="qn-cropper"
		title="裁剪"
		v-on="$listeners">
		<vue-cropper
			ref="qnCropper"
			v-bind="$attrs"
            mode="cover"
			:img="data.url"
			:output-size="outputSize"
			:info-true="infoTrue"
			:can-scale="canScale"
			:auto-crop="autoCrop"
            :auto-crop-width="autoCropWidth"
            :auto-crop-height="autoCropHeight"
            :fixed="fixed"
            :fixed-number="fixedNumber"
			:fixed-box="fixedBox"
			:can-move-box="canMoveBox"
			:centerBox="centerBox"
			:output-type="outputType"
            :enlarge="enlarge"
			:style="{ width, height }" />
		<el-button-group v-if="funBar">
			<el-button
				title="旋转"
				@click="handleRotateLeft">
				旋转
			</el-button>
			<el-button
				title="放大"
				@click="handleScalePlus">
				放大
			</el-button>
			<el-button
				title="缩小"
				@click="handleScaleSubtract">
				缩小
			</el-button>
		</el-button-group>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="handleToConfirm">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { VueCropper } from 'vue-cropper'

export default {
	name: 'QnCropper',
	components: {
		VueCropper
	},
	inheritAttrs: false,
	props: {
		// 裁剪图片的地址
		data: {
			type: Object,
			default() {
				return {
					name: '',
					uid: '',
					url: ''
				}
			}
		},
        // 裁剪后的分辨率
		resolution: {
			type: String
		},
		// 裁剪生成图片的质量
		outputSize: {
			type: Number,
			default: 1 // 0.1 ~ 1
		},
		// 裁剪框的大小信息
		infoTrue: {
			type: Boolean,
			default: true
		},
		// 图片是否允许滚轮缩放
		canScale: {
			type: Boolean,
			default: true
		},
		// 是否默认生成截图框
		autoCrop: {
			type: Boolean,
			default: true
		},
        // 默认生成截图框宽度
        autoCropWidth: {
            type: Number,
            default: 200
        },
        // 默认生成截图框高度
        autoCropHeight: {
            type: Number,
            default: 200
        },
		// 截图框能否拖动
		canMoveBox: {
			type: Boolean,
			default: true
		},
		// 截图框是否被限制在图片里面
		centerBox: {
			type: Boolean,
			default: false
		},
		// 容器宽度
		width: {
			type: String,
			default: '400px'
		},
		// 容器高度
		height: {
			type: String,
			default: '400px'
		},
        // 是否显示功能栏
		funBar: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		// 裁剪生成图片的格式
		outputType() {
			const name = this.data.name
			if (!name) return ''
			const i = name.lastIndexOf('.')
			let suffix = name.slice(i + 1)
			suffix = suffix === 'jpg' ? 'jpeg' : suffix
			return suffix
		},
        // 是否开启截图框宽高固定比例
        fixed() {
            return this.resolution ? true : false
        },
		// 截图框的宽高比例, 开启fixed生效
		fixedNumber() {
			if (this.resolution) {
                const [w, h] = this.resolution.split('*')
				return [Number(w), Number(h)]
			}
			return [200, 200]
		},
        // 固定截图框大小
        fixedBox() {
            return this.resolution ? true : false
        },
        // 图片根据截图框输出比例倍数
        enlarge() {
            return this.fixedNumber[0] / this.autoCropWidth
        }
	},
	methods: {
		handleToConfirm() {
			this.$refs.qnCropper.getCropBlob(res => {
				const rawFile = new File([res], this.data.name, { type: `image/${this.outputType}` })
                rawFile.uid = this.data.uid
                // 和上传组件构建的file保持一致
				const file = {
                    status: 'ready',
                    name: rawFile.name,
                    size: rawFile.size,
                    percentage: 0,
                    uid: rawFile.uid,
                    raw: rawFile
                }
                try {
                    file.url = URL.createObjectURL(rawFile)
                } catch (err) {
                    console.error(err)
                    return
                }
				this.$emit('success', file)
				this.close()
			})
		},
		handleRotateLeft() {
			this.$refs.qnCropper.rotateLeft()
		},
		handleScalePlus() {
			this.$refs.qnCropper.changeScale(1)
		},
		handleScaleSubtract() {
			this.$refs.qnCropper.changeScale(-1)
		},
		close() {
			this.$emit('update:visible', false)
		}
	}
}
</script>

<style ref="stylesheet/scss" lang="scss" scoped>

.qn-cropper /deep/ {

	.el-dialog--small {
		width: 440px;
	}

	.el-dialog__body {
		text-align: right;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/QnUpload-1.vue?12e584d2